import { create } from "zustand";
import { MAX_HISTORY_LENGTH } from "../constants/defaults";
import { usePlacedModelsStore } from "./placedModelsStore";

export const useHistoryStore = create((set, get) => ({
  undoStack: [],
  redoStack: [],

  push: (stateSnapshot) =>
    set((state) => {
      const newUndoStack = [...state.undoStack, stateSnapshot];
      if (newUndoStack.length > MAX_HISTORY_LENGTH) {
        newUndoStack.shift();
      }

      return {
        undoStack: newUndoStack,
        redoStack: [],
      };
    }),

  undo: () => {
    const { undoStack, redoStack } = get();
    if (undoStack.length === 0) return;

    const previous = undoStack[undoStack.length - 1];
    set({
      undoStack: undoStack.slice(0, -1),
      redoStack: [...redoStack, usePlacedModelsStore.getState().placedModels],
    });
    usePlacedModelsStore.setState({ placedModels: previous });
  },

  redo: () => {
    const { redoStack, undoStack } = get();
    if (redoStack.length === 0) return;

    const next = redoStack[redoStack.length - 1];
    set({
      redoStack: redoStack.slice(0, -1),
      undoStack: [...undoStack, usePlacedModelsStore.getState().placedModels],
    });
    usePlacedModelsStore.setState({ placedModels: next });
  },

  clearHistory: () => set({ undoStack: [], redoStack: [] }),
}));
